import { List, ListSubheader, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { MapPinInfo } from 'features/mapping/components/MapPinDrawerContent/MapPinInfo';
import {
  showFireInfoForEvent,
  showFloodingInfoForEvent,
} from 'pages/ExternalGeoEventDetails/ExternalGeoEventDetails.utils';
import { ExternalGeoEvent } from 'shared/types';

type ExternalGeoEventLocationProps = {
  event: ExternalGeoEvent;
};

export const ExternalGeoEventLocation = (
  props: ExternalGeoEventLocationProps,
): JSX.Element => {
  const { event } = props;
  const { t } = useTranslation();

  return (
    <List
      subheader={
        <ListSubheader variant="watchduty-section-header">
          <Typography variant="h3">
            {t('externalGeoEvent.locationHeader')}
          </Typography>
        </ListSubheader>
      }
    >
      <MapPinInfo
        coordinates={event}
        showSlackLinks={false}
        showFireInfo={showFireInfoForEvent(event)}
        showFloodingInfo={showFloodingInfoForEvent(event)}
      />
    </List>
  );
};
